module.exports = __webpack_public_path__ + "be.svg?38ee10d53fcbecfede7bdeef6bc68a30";